var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('ToznyLoader',{staticClass:"text-tozny w-8 h-8"}):_c('button',[_vm._v(_vm._s(_vm.buttonText))])
}
var staticRenderFns = []

export { render, staticRenderFns }